module.exports = __webpack_public_path__ + "img/check-white.9dc4633f.svg";